/**
 * Asynchronously loads the component for MatchProfile
 */

import { lazyLoad } from "utils/loadable";

export const MatchProfile = lazyLoad(
  () => import("./index"),
  (module) => module.MatchProfile
);
